import React from 'react';
import Brick from './BrickCore';
import i18n from '../../locales/i18n';

/**
 * Brick representing an explicit pause until payment is confirmed.
 */
class WaitPaymentBrick extends Brick {
    run(context, isEmbedded, onDone) {
        onDone(context);
        return (
            <div className="alert alert-info">
                {i18n.t('workflows.waiting_for_payment_confirmation')}
            </div>
        );
    }
}

export default WaitPaymentBrick;
